// removed by extract-text-webpack-plugin
module.exports = {"Container":"ResumeBox__Container___2H1af","Center":"ResumeBox__Center___1kMy4"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/ResumeBox/ResumeBox.css
// module id = 27
// module chunks = 0